import React from 'react';
import { Link, LinkProps } from '@material-ui/core';
import { useStyles } from './LinkPrimaryStyles';
import clsx from 'clsx';

interface ILinkPrimary extends LinkProps {
  disabled?: boolean;
}

export const LinkPrimary: React.FC<ILinkPrimary> = ({
  href,
  onClick,
  children,
  className,
  underline,
  disabled,
}: ILinkPrimary) => {
  const classes = useStyles();

  if (disabled) {
    return <Link className={classes.disabled}>{children}</Link>;
  } else {
    const isLinkAnchor = !!href?.length;

    if (isLinkAnchor) {
      return (
        <Link
          component="a"
          className={clsx(classes.root, className, underline !== 'none' ? classes.underline : '')}
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={onClick}
        >
          {children}
        </Link>
      );
    } else {
      return (
        <Link
          component="button"
          className={clsx(classes.root, className, underline !== 'none' ? classes.underline : '')}
          onClick={onClick}
        >
          {children}
        </Link>
      );
    }

  }
};

LinkPrimary.defaultProps = {
  disabled: false,
};

export default LinkPrimary;
